/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "26f05504d23028c616156d16700574b7a037fdae";
